import { qs } from "scripts/data_utils/domHelpers";
import { fetchPrintedCost } from "scripts/data_utils/fetch_cost";
import numberProcessor from "scripts/data_utils/number_processor";
import { MIN_PAGE_COUNT, MAX_PAGE_COUNT } from "scripts/constants";

class Calculator {
  constructor(calculator) {
    this.calculator = calculator;
    this.pagesCountInput = qs(".js-pages-count", calculator);
    this.itemsCountInput = qs(".js-items-count", calculator);
    this.resultCostContainer = qs(".js-result-cost", calculator);
    this.resultCostOneContainer = qs(".js-result-one-cost", calculator);
    this.calculateBtn = qs(".js-calculate", calculator);
    this.addEventListeners();
    this.calculate();
  }

  async calculate() {
    this.pagesCountInput.value = numberProcessor({
      inputValue: this.pagesCountInput.value,
      options: {
        range: [MIN_PAGE_COUNT, MAX_PAGE_COUNT]
      }
    });
    this.itemsCountInput.value = numberProcessor({
      inputValue: this.itemsCountInput.value,
      options: {
        range: [1, MAX_PAGE_COUNT]
      }
    });
    const pagesCount = this.pagesCountInput.value;
    const itemCount = this.itemsCountInput.value;
    this.calculateBtn.innerHTML = 'Расчёт стоимости <span class="loader-round"></span>';
    this.calculateBtn.disabled = true;
    let printCost;

    try {
      const {
        print_cost
      } = await fetchPrintedCost({
        pagesCount,
        itemCount
      });
      printCost = print_cost;
    } catch (error) {
      this.calculateBtn.innerHTML = "Расчёт стоимости";
      return;
    }

    this.calculateBtn.disabled = false;
    this.calculateBtn.innerHTML = "Рассчитать стоимость";
    this.resultCostContainer.innerHTML = `${numberProcessor({
      inputValue: Math.floor(printCost),
      options: {
        format: true
      }
    })}&nbsp;₽`;
    this.resultCostOneContainer.innerHTML = `${numberProcessor({
      inputValue: Math.floor(printCost / itemCount),
      options: {
        format: true
      }
    })}&nbsp;₽`;
  }

  addEventListeners() {
    this.calculateBtn.addEventListener("click", e => {
      e.preventDefault();
      this.calculate();
    });
  }

}

export default Calculator;